import { render, staticRenderFns } from "./allClasses.vue?vue&type=template&id=6774c031&scoped=true"
import script from "./allClasses.vue?vue&type=script&lang=js"
export * from "./allClasses.vue?vue&type=script&lang=js"
import style0 from "./allClasses.vue?vue&type=style&index=0&id=6774c031&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6774c031",
  null
  
)

export default component.exports